import { render, staticRenderFns } from "./ClientTestimonials.vue?vue&type=template&id=ea6a27ee&scoped=true&"
import script from "./ClientTestimonials.vue?vue&type=script&lang=js&"
export * from "./ClientTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ClientTestimonials.vue?vue&type=style&index=0&id=ea6a27ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6a27ee",
  null
  
)

export default component.exports